import axios from 'axios';

const instance = axios.create({baseURL: 'http://localhost/practice_kiya/api/v1/'});
//instance.defaults.headers.common['Content-Type'] = 'multipart/form-data';
//instance.defaults.headers.common['Authorization'] = "Bearer "+localStorage.getItem('_user_token');

export default instance